import { connect } from 'react-redux'
import { IStoreState, ICreateTeamMemberPermissionDTO, IUpdateTeamMemberPermissionDTO } from '../../types'
import TeamMemberPermissionEditForm from '../../components/team-members/form/TeamMemberPermissionEditForm'
import {
  fetchTeamMemberPermission,
  createTeamMemberPermission,
  updateTeamMemberPermission
} from '../../state/actions/team-member-permission'
import { fetchServiceList } from '../../state/actions/services'
import { SERVICE_LIST_TYPE } from '../../state/constants/index'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const { id, handleRedirect } = ownProps
  return {
    handleRedirect,
    id,
    orgId: state.organizations.currentOrgId,
    permission: state.teamMemberPermission,
    services: Object.values(state.service.items)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchTeamMemberPermission: (id: string) => dispatch(fetchTeamMemberPermission(id)),
    createTeamMemberPermission: (tmp: ICreateTeamMemberPermissionDTO) => dispatch(createTeamMemberPermission(tmp)),
    updateTeamMemberPermission: (tmp: IUpdateTeamMemberPermissionDTO) => dispatch(updateTeamMemberPermission(tmp)),
    fetchServices: (orgId: string) => dispatch(fetchServiceList(SERVICE_LIST_TYPE.ACTIVE, orgId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberPermissionEditForm)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberPermissionEditForm.ts